import React from 'react';

/**
 * Horizontal section tabs for the in-app help drawer — one tab per
 * `helpSections` entry (icon + label), driving which section's topics
 * HelpContent renders.
 */
export default function HelpNav({ sections, activeSectionId, onSelectSection }) {
  return (
    <ul className="nav nav-tabs help-drawer-section-nav px-3 pt-2" role="tablist">
      {sections.map((section) => (
        <li className="nav-item" key={section.id} role="presentation">
          <button
            type="button"
            className={`nav-link${section.id === activeSectionId ? ' active' : ''}`}
            onClick={() => onSelectSection(section.id)}
            role="tab"
            aria-selected={section.id === activeSectionId}
          >
            {section.icon ? <i className={`${section.icon} me-2`} aria-hidden="true"></i> : null}
            {section.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
